// extracted by mini-css-extract-plugin
export default {"expiration":"expiration_expiration__6Z0JV","label":"expiration_label__wAi9T","date":"expiration_date__OWWTS","icon":"expiration_icon__oAvnd","calendar":"expiration_calendar__QINtu"};